module.exports = __webpack_public_path__ + "assets/0c5f3f72cbfc77f0356e8a1d7804580f.png";